/*=============================================================================
 * KFIT 金证基金网上交易系统 V3.0
 * Copyright(c) 1998-2012 SZKingdom Co. Ltd. 
 * All right reserved. 
 *-----------------------------------------------------------------------------
 * 登录页面（Login.html）控制
 * 
 * 修改历史：
 *----------------------------------------------------------------------------
 * 修改时间	                                          修改人            修改内容        
 * 2012-03-01 00:00 river   创建
 *============================================================================*/

function Login() {
	// 初始化DOM变量
	var $LoginMode = null; // 登录类型
	var $Account = null; // 证件号
	var $Password = null; // 登录密码
	var $VerifyCode = null; // 验证码
	var $ImgVerifyCode = null; // 图片验证码
	var lastCheckTime = null;
	var PerCertType;
	var cookieInvtp = "1",cookieLoginMode = "A0";
	var webTradeSpan, acctQrySpan, tradeImgLink, qryImgLink;
	var _this, timerID = -1;
	var isOrg = "1";
	var oUrlParam = new URL().params;
	var oPerCertType = KGD.PerCertType;
    var OrgCertType = KGD.OrgCertType;
	var oProducttype = KGD.Producttype; 
	
	/**
	 * 初始化页面DOM对象
	 */
	this.initialize = function() {
		 oPerCertType.unshift('00','基金账号');
		 oPerCertType.unshift('A0','手机号');
		 OrgCertType.unshift('00','基金账号');
		 oProducttype.unshift('00','基金账号');
		// session过期就跳出iframe框架
		if (window != top)
			top.location.href = location.href;
		// 执行父类中的initialize方法
		this.$Super.initialize.apply(this, arguments);
		// 初始化DOM变量
		$LoginMode = $("#slMode");
		$Account = $("#txtAccount");
		$Password = $("#txtPassword");
		$VerifyCode = $("#txtVerifyCode");
		$ImgVerifyCode = $("#imgVerifyCode");

		
		cookieLoginMode = getCookieValue("slMode") || "A0";
		//cookieInvtp = getCookieValue("sInvtp") || "1" ;	
		//个人版
		cookieInvtp = "1" ;
		if (cookieInvtp == "1") {
			isOrg = "1";
			initPersonForm();
		} else if(cookieInvtp=="0"){
			initOrgForm();
			isOrg = "0";
		}else{
			initProForm();
			isOrg = "2";
		}
		$LoginMode.find("option[value=" + cookieLoginMode + "]").attr("selected", true);
		if (getCookieValue("saveflag")) {
			$("#txtAccount").val(getCookieValue("txtAccount"));
		}
		$("#saveflag").prop("checked",
				getCookieValue("saveflag") ? true : false);

		// 初始化DOM事件
		$("#btnLogin").click($.proxy(this.onLoginClick, this));
		$("#memberRegister").click($.proxy(this.onOpenAccountClick, this));
		$("#KeyBoardForgest").click($.proxy(this.onForgotPwd, this));

		$("#aLoadImage").click(function() {
			oLogin.onLoadImageClick();
		});
		$("#aLoadImage1").click(function() {
			oLogin.onLoadImageClick();
		});
		// 获取验证码
		//this.onLoadImageClick();
		this.blurCheck();
		document.onkeydown = function(e) {
			var currKey = 0, ev = e || event;
			currKey = ev.keyCode || ev.which || ev.charCode;// 支持IE、FF
			if (document.activeElement.id != 'btnLogin' && currKey == 13) {
				oLogin.onLoginClick(ev);
			}
		};
		_this = $('#ulNote');
		_this.hover(function() {
			clearInterval(timerID);
		}, function() {
			timerID = setInterval("scrollUp()", 2000);
		}).mouseout();
		scrollUp = function() {
			var $second = _this.find("li:first");
			var $last = _this.find("li:last");
			$last.insertBefore($second);
		};
		$("#txtPassword").hide();
        
        $("#txtPassword_over").focus(function(){
    		$(this).hide();
			$("#txtPassword").show();
    		$("#txtPassword").focus();
		});
        $("#txtPassword_over").keydown(function(){
    		$(this).hide();
    		$("#txtPassword").show();
    	});
        $("#txtPassword").focus(function(){$(this).click();});
    	$("#txtPassword").blur(function(){
    		if($("#txtPassword").val()==""){
    			$("#txtPassword").hide();
    			$("#txtPassword_over").show();
    			$("#txtPassword_over").val("请输入交易密码");
    			
    		}
    	});
    	$("#saveflag").attr("checked",true);
    	$("#forgetPwd").click($.proxy(forget, this));  
    	inittxtAccount();
    	$("#slMode").bind("change",function(){
    		inittxtAccount("noinit");
    	});
    	
	};

	this.finalize = function() {
		this.$Super.finalize.apply(this, arguments);
	};

	this.onForgotPwd = function() {
		KGF.gotoPage("../../page/frame/MainFrame.html?type=2");
	};

	/**
	 * 点击刷新重获校验码图片
	 */
	this.onLoadImageClick = function() {
		var iHeight = Math.ceil($VerifyCode.outerHeight());
		$ImgVerifyCode.attr("src", "../../authImg?width=140&count=4"
				+ "&height=" + iHeight + "&time=" + (new Date()).getTime());
		$VerifyCode.val("");
	};
	
	function inittxtAccount(flag){
    	if("A0" == $("#slMode").val()){
    		if ("noinit"  == flag || "请输入您的手机号" == $("#txtAccount").val() || "请输入您的证件号码" == $("#txtAccount").val() ) {
    			$("#txtAccount").attr("value","请输入您的手机号");
    		}
    		$("#txtAccount").attr("onfocus","if(this.value=='请输入您的手机号'||this.value=='请输入您的证件号码'){this.value='';oLogin.blurCheck()};this.style.color='#999'");
    		$("#txtAccount").attr("onblur","if(this.value==''||this.value=='请输入您的手机号'||this.value=='请输入您的证件号码'){this.value='请输入您的手机号';this.style.color='#999';oLogin.blurCheck()}");
    	}else{
     		if ("noinit"  == flag || "请输入您的手机号" == $("#txtAccount").val() || "请输入您的证件号码" == $("#txtAccount").val() ) {
    			$("#txtAccount").attr("value","请输入您的证件号码");
    		}
    		$("#txtAccount").attr("onfocus","if(this.value=='请输入您的证件号码'||this.value=='请输入您的手机号'){this.value='';oLogin.blurCheck()};this.style.color='#999'");	
    		$("#txtAccount").attr("onblur","if(this.value==''||this.value=='请输入您的证件号码'||this.value=='请输入您的手机号'){this.value='请输入您的证件号码';this.style.color='#999';oLogin.blurCheck()}");
    	}
	}
	function forget(){
		$("#forgetPwd").attr("href","MainFrame.html?type=2&&isOrg="+isOrg+"&version="+new Date().getTime());
	}
	function initPersonForm(){
		$('#txtVerifyCode').val('');
		$('#invtp2Select').removeClass();
		$('#invtp2Select').addClass('nocurSelect');
		$('#invtp1Select').removeClass();
		$('#invtp1Select').addClass('currentSelect');
		$('#invtp0Select').removeClass();
		$('#invtp0Select').addClass('nocurSelect');
		$("#invtp1").attr("checked", "checked");
		KDom.addSelectOption("slMode", oPerCertType, [ "value" ], [ "key" ],true, "A0");
		if("1" == cookieInvtp){
			$LoginMode.find("option[value=" + cookieLoginMode + "]").attr("selected", true);
			if (getCookieValue("saveflag")) {
				$("#txtAccount").val(getCookieValue("txtAccount"));
			}
		}else{
			$("#txtAccount").val("请输入您的证件号码");
			$("#txtPassword_over").show();
			$("#txtPassword").hide().val("");
		}
		$("#institute").css("color", "#696969");
		$("#institute_tips").css({
			"background-color" : "#696969",
			"height" : "1px",
			"margin-top" : "3px"
		});
		$("#product").css("color", "#696969");
		$("#product_tips").css({
			"background-color" : "#696969",
			"height" : "1px",
			"margin-top" : "3px"
		});
		$("#person").css("color", "#FD8900");
		$("#person_tips").css({
			"background-color" : "#FD8900",
			"height" : "3px",
			"margin-top" : "2px"
		});
		inittxtAccount();
	}
	
	function initOrgForm(){
		$('#txtVerifyCode').val('');
		$('#invtp2Select').removeClass();
		$('#invtp2Select').addClass('nocurSelect');
		$('#invtp0Select').removeClass();
		$('#invtp0Select').addClass('currentSelect');
		$('#invtp1Select').removeClass();
		$('#invtp1Select').addClass('nocurSelect');
		$("#invtp0").attr("checked", "checked");
		KDom.addSelectOption("slMode", OrgCertType, [ "value" ], [ "key" ],true, "00");
		if("0" == cookieInvtp){
			$LoginMode.find("option[value=" + cookieLoginMode + "]").attr("selected", true);
			if (getCookieValue("saveflag")) {
				$("#txtAccount").val(getCookieValue("txtAccount"));
			}
		}else{
			$("#txtAccount").val("请输入您的证件号码");
			$("#txtPassword_over").show();
			$("#txtPassword").hide().val("");
		}
		$("#institute").css("color", "#FD8900");
		$("#institute_tips").css({
			"background-color" : "#FD8900",
			"height" : "3px",
			"margin-top" : "2px"
		});
		$("#person").css("color", "#696969");
		$("#person_tips").css({
			"background-color" : "#696969",
			"height" : "1px",
			"margin-top" : "3px"
		});
		$("#product").css("color", "#696969");
		$("#product_tips").css({
			"background-color" : "#696969",
			"height" : "1px",
			"margin-top" : "3px"
		});
		inittxtAccount();
	}
	
	function initProForm(){
		$('#txtVerifyCode').val('');
		$('#invtp2Select').removeClass();
		$('#invtp2Select').addClass('currentSelect');
		$('#invtp0Select').removeClass();
		$('#invtp0Select').addClass('nocurSelect');
		$('#invtp1Select').removeClass();
		$('#invtp1Select').addClass('nocurSelect');
		$("#invtp2").attr("checked", "checked");
		KDom.addSelectOption("slMode", oProducttype, [ "value" ], [ "key" ],true, "00");
		if("2" == cookieInvtp){
			$LoginMode.find("option[value=" + cookieLoginMode + "]").attr("selected", true);
			if (getCookieValue("saveflag")) {
				$("#txtAccount").val(getCookieValue("txtAccount"));
			}
		}else{
			$("#txtAccount").val("请输入您的证件号码");
			$("#txtPassword_over").show();
			$("#txtPassword").hide().val("");
		}
		$("#product").css("color", "#FD8900");
		$("#product_tips").css({
			"background-color" : "#FD8900",
			"height" : "3px",
			"margin-top" : "2px"
		});
		$("#person").css("color", "#696969");
		$("#person_tips").css({
			"background-color" : "#696969",
			"height" : "1px",
			"margin-top" : "3px"
		});
		$("#institute").css("color", "#696969");
		$("#institute_tips").css({
			"background-color" : "#696969",
			"height" : "1px",
			"margin-top" : "3px"
		});
	}
	function setCookie(sName, sValue, hours, path) {
		var name = escape(sName);
		var value = escape(sValue);
		var expires = new Date();
		expires.setTime(expires.getTime() + hours * 3600000);
		path = path == "" ? "" : ";path=" + path;
		_expires = (typeof hours) == "string" ? "" : ";expires="
				+ expires.toUTCString();
		document.cookie = name + "=" + value + _expires + path;
	}

	// 获取cookie值
	function getCookieValue(sName) {
		var name = escape(sName);
		var allcookies = document.cookie;
		name += "=";
		var pos = allcookies.indexOf(name);
		if (pos != -1) { // 如果pos值为-1则说明搜索"version="失败
			var start = pos + name.length; // cookie值开始的位置
			var end = allcookies.indexOf(";", start); // 从cookie值开始的位置起搜索第一个";"的位置,即cookie值结尾的位置
			if (end == -1)
				end = allcookies.length; // 如果end值为-1说明cookie列表里只有一个cookie
			var value = allcookies.substring(start, end); // 提取cookie的值
			return (value); // 对它解码
		} else
			return ""; // 搜索失败，返回空字符串
	}
	function deleteCookie(sName, path) {
		var name = escape(sName);
		var expires = new Date(0);
		path = path == "" ? "" : ";path=" + path;
		document.cookie = name + "=" + ";expires=" + expires.toUTCString()
				+ path;
	}
	/**
	 * 点击登录按钮验证登录
	 */
	this.onLoginClick = function(event) {
		// 验证输入数据
		if (!this.validate())
			return;
		var sInvtp = getCheckedRadioValue("invtp");
		setCookie("sInvtp", sInvtp, 720, "/");
		setCookie("slMode", $("#slMode").val(), 720, "/");
		if ($("#saveflag").prop("checked") == true) {
			setCookie("txtAccount", $("#txtAccount").val(), 720, "/");
			setCookie("saveflag", 1, 720, "/");
		} else {
			deleteCookie("txtAccount", "/");
			deleteCookie("saveflag", "/");
		}
		var sAccttype;
		var sLoginMode = $("#slMode").val();
		var sAccount = $("#txtAccount").val();
		var sPassword = encData($("#txtPassword").val());
		var sVerifyCode = $("#txtVerifyCode").val();
		if (sInvtp == "1" && sLoginMode == '0') {
			sAccount = sAccount.replace('x', 'X');
		}
		if (sLoginMode == '00') {// 基金帐号登录，转换
			sAccttype = '2';
			sLoginMode = '0';
			if (sAccount.length > 12) {
				KDlg.info("基金账号格式不正确！");
				return;
			}
		} else {
			sAccttype = '7';
			if (sLoginMode == '07') {
				sAccount = 'VIP' + sLoginId;
				sLoginMode = '7';
			} else if (sLoginMode == '007') {
				sAccount = 'WEB' + sLoginId;
				sLoginMode = '7';
			} else if (sLoginMode == 'A0') {
				if (!KGF.isPhoneStr(sAccount)) {
					KDlg.info("手机号格式不正确！");
					return;
				}
				sLoginMode = '';
				sAccttype = 'a';
			}
		}
		// 以表单方式提交
		var oParam = new ListMap();
		oParam.set("accttype", sAccttype);
		oParam.set("certificateno", sAccount);
		oParam.set("lpasswd", sPassword);
		oParam.set("verifycode", sVerifyCode);
		oParam.set("certificatetype", sLoginMode);
		oParam.set("fundcode", oUrlParam.get("fundcode", ""));
		oParam.set("business", oUrlParam.get("business", ""));
		oParam.set("referral", oUrlParam.get("referral", ""));
		oParam.set("referralmobile", oUrlParam.get("referralmobile", ""));
		oParam.set("invtp", sInvtp);
		KDom.initPostForm(null, "j_spring_security_check", oParam, false, true);
	};

	this.changeTp = function(t) {
		document.getElementById("slMode").options.length = 1;
		if("2" == t){
			isOrg = "2";
			initProForm();
		}else if ("0" == t) {
			isOrg = "0";
			initOrgForm();
		} else {
			isOrg = "1";
			initPersonForm();
		}
	};
	/**
	 * 开户
	 */
	this.onOpenAccountClick = function(event) {
		var uid = oUrlParam.get("uid","");
    	var utel = oUrlParam.get("utel","");
		var regu = /^[a-zA-Z0-9\u4e00-\u9fa5]+$/;
		var re = new RegExp(regu);
		if(!re.test(uid)){
			uid="";
		}
		var isMobile = KGF.isPhoneStr(utel);
		if(!isMobile){
			utel ="";
		}	
		if(isOrg =="1"){
			KGF.gotoPage("../../page/frame/MainFrame.html?type=1&uid="+uid+"&utel="+utel);
		}else if(isOrg=="2"){
			KGF.gotoPage("../../page/frame/MainFrame.html?type=6&uid="+uid+"&utel="+utel+"&flag=2");
		}else {
			KGF.gotoPage("../../page/frame/MainFrame.html?type=5&uid="+uid+"&utel="+utel+"&flag=0");
		}
		
	};

	this.blurCheck = function() {
		var curTime = new Date().getTime();
		var befTime = lastCheckTime != null ? lastCheckTime : curTime;
		if (curTime - befTime < 30000 && curTime - befTime > 0)
			return;
		lastCheckTime = curTime;
		Ajax.request("isRefreshCode.do", {}, function(ajaxResult) {
			if (!ajaxResult.isSuccess()) {
				KDom.display("TrtxtVerifyCode", true);
				$('#isFtLg')[0].value = "1";
				oLogin.onLoadImageClick();
				$("#login-body").css("height","415px");
				$(".login_form_background_white").css("height","415px");
			} else {
				KDom.display("TrtxtVerifyCode", false);
				$('#isFtLg')[0].value = "0";
				$("#login-body").css("height","350px");
				$(".login_form_background_white").css("height","350px");
			}
		}, true, "json", false);
	};
	
	/**
	 * 验证登录输入数据是否合法
	 */
	this.validate = function() {
		if (KGF.isEmpty($Account.val())) {
			KDlg.info("登录账号不能为空。");
			$Account.focus();
			return false;
		}

		if ($.trim($Account.val()).length != $Account.val().length) {
			KDlg.info("登录账号不能包含空格。");
			$Account.focus();
			return false;
		}

		if ($LoginMode.val() == "0" && $('#invtp1')[0].checked) {
			if (KGF.isValidIDCardNo($Account.val()) != "true") {
				KDlg.info("身份证输入不正确。");
				$Account.focus();
				return false;
			}
		}

		if (KGF.isEmpty($.trim($Password.val()))) {
			KDlg.info("密码不能为空。");
			$Password.focus();
			return false;
		} else if (!KGF.isValidPwd($Password.val())) {
			KDlg.info("密码输入格式不合法。");
			$Password.focus();
			return false;
		}

		if ($('#isFtLg')[0].value == "1"
				&& KGF.isEmpty($.trim($VerifyCode.val()))) {
			KDlg.info("验证码不能为空。");
			$VerifyCode.focus();
			return false;
		}
		return true;
	};
};
// 加载Javascript页面控制类
loadJsPageClass("Login");

//# sourceMappingURL=../../sourcemaps/page/frame/Login.js.map
